'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Settings = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

var _utilsList = require('@bibliocommons/utils-list');

var _propertyDropdown = require('../../property-dropdown');

var _propertyDropdown2 = _interopRequireDefault(_propertyDropdown);

var _closeButton = require('../../close-button');

var _closeButton2 = _interopRequireDefault(_closeButton);

var _addItemsToTopCheckbox = require('../../add-items-to-top-checkbox');

var _addItemsToTopCheckbox2 = _interopRequireDefault(_addItemsToTopCheckbox);

var _rankedToggle = require('../../ranked-toggle');

var _rankedToggle2 = _interopRequireDefault(_rankedToggle);

var _visibilityStatus = require('../../visibility-status');

var _visibilityStatus2 = _interopRequireDefault(_visibilityStatus);

require('../styles/Settings.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Settings = exports.Settings = function (_BcReactComponent) {
  _inherits(Settings, _BcReactComponent);

  function Settings(props) {
    _classCallCheck(this, Settings);

    var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));

    _this.bindAll('renderListScope', 'renderListLanguage', 'renderVisibilityStatus');
    return _this;
  }

  _createClass(Settings, [{
    key: 'renderListScope',
    value: function renderListScope() {
      var _props = this.props,
          listScopes = _props.listScopes,
          list = _props.list,
          intl = _props.intl,
          handleListPropertyChange = _props.handleListPropertyChange;

      var scopedListTypes = ['staff_picks', 'teacher_picks'];

      if (scopedListTypes.includes(list.get('listType')) && listScopes.keySeq().size >= 1) {
        return _react2.default.createElement(_propertyDropdown2.default, {
          property: 'agencyScope',
          staffOnly: true,
          label: intl.formatMessage({ id: 'user_lists_scope' }),
          list: list,
          options: listScopes,
          handleListPropertyChange: handleListPropertyChange });
      }

      return null;
    }
  }, {
    key: 'renderListLanguage',
    value: function renderListLanguage() {
      var _props2 = this.props,
          listLanguages = _props2.listLanguages,
          list = _props2.list,
          intl = _props2.intl,
          handleListPropertyChange = _props2.handleListPropertyChange;

      if ((0, _utilsList.isStaffOnlyList)(list) && listLanguages.keySeq().size > 1) {
        return _react2.default.createElement(_propertyDropdown2.default, {
          property: 'language',
          label: intl.formatMessage({ id: 'user_lists_language' }),
          list: list,
          options: listLanguages,
          handleListPropertyChange: handleListPropertyChange });
      }

      return null;
    }
  }, {
    key: 'renderVisibilityStatus',
    value: function renderVisibilityStatus() {
      var _props3 = this.props,
          list = _props3.list,
          listLocales = _props3.listLocales;

      if (!(0, _utilsList.isStaffOnlyList)(list)) {
        return _react2.default.createElement(_visibilityStatus2.default, { list: list, listLocales: listLocales });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'form',
        { className: 'cp-user-list-settings', action: '' },
        _react2.default.createElement(
          'div',
          { className: 'settings-content' },
          _react2.default.createElement(
            'h2',
            {
              className: 'settings-title',
              tabIndex: '-1',
              ref: function ref(element) {
                _this2.listSettingsTitle = element;
              } },
            _react2.default.createElement(_baseIcons.Cog, null),
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_settings_title' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'general-options' },
            _react2.default.createElement(_addItemsToTopCheckbox2.default, {
              value: this.props.addItemsToTop,
              handleChange: this.props.handleAddItemsToTopChange }),
            _react2.default.createElement(_rankedToggle2.default, {
              isRanked: this.props.list.get('isRanked'),
              handleListPropertyChange: this.props.handleListPropertyChange }),
            this.renderListScope(),
            this.renderListLanguage(),
            this.renderVisibilityStatus()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'controls' },
          _react2.default.createElement(_closeButton2.default, { handleClick: this.props.handleToggleSettingsMenu })
        )
      );
    }
  }]);

  return Settings;
}(_baseBcReactComponent2.default);

Settings.propTypes = {
  list: _bcPropTypes.listShape.isRequired,
  items: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  handleListPropertyChange: _react.PropTypes.func.isRequired,
  addItemsToTop: _react.PropTypes.bool,
  listScopes: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string),
  listLanguages: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string),
  listLocales: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string),
  selectableListTypes: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  handleToggleSettingsMenu: _react.PropTypes.func.isRequired,
  handleAddItemsToTopChange: _react.PropTypes.func.isRequired,
  intl: _reactIntl.intlShape
};

exports.default = (0, _reactIntl.injectIntl)(Settings);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/settings/components/Settings.component.js
// module id = 1341
// module chunks = 0